import React, { useEffect, useState } from "react";
import { makeAPI } from "../services/api";
import { Link } from "react-router-dom";

// In Build settings include all scenes that are needed for the game.

export default function GameJamV3() {

  const user = JSON.parse(localStorage.getItem('user'));

  //gamejam config data's.
  const [game_jam, setgame_jam] = useState('');
  const [user_register_stat, setuser_register_stat] = useState(false);
  const [timeLeft, setTimeLeft] = useState({ dd: '00', hh: '00', mm: '00', ss: '00' });
  const [Games, setGames] = useState([]);
  const isSubmissionEnded =
    Boolean(game_jam?.is_ends_on || game_jam?.vote_end_dt) &&
    !game_jam?.is_upcoming &&
    timeLeft.dd === "00" &&
    timeLeft.hh === "00" &&
    timeLeft.mm === "00" &&
    timeLeft.ss === "00";
    // 

  useEffect(() => {
    document.title = "GameJam 2026 - CGES.CLUB";
    document.querySelectorAll('.gf-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.gf-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
      });
    });

    GameJamConfig();



    /* ── SCROLL REVEAL ── */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('on'); }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.rv').forEach(function (el, i) {
      var siblings = Array.from(el.parentElement.children).filter(function (c) { return c.classList.contains('rv'); });
      var idx = siblings.indexOf(el);
      el.style.transitionDelay = Math.min(idx * 0.07, 0.35) + 's';
      io.observe(el);
    });
  }, []);

  useEffect(() => {
    // const end = game_jam?.sub_end_dt ? new Date(game_jam.sub_end_dt) : new Date();
    let end = '';
    if (game_jam?.is_upcoming) {
      end = game_jam?.sub_start_dt ? new Date(game_jam.sub_start_dt) : new Date();
    } else {
      end = game_jam?.sub_end_dt ? new Date(game_jam.sub_end_dt) : new Date();
    }

    const tick = () => {
      const d = Math.max(0, end - Date.now());
      setTimeLeft({
        dd: String(Math.floor(d / 86400000)).padStart(2, '0'),
        hh: String(Math.floor((d % 86400000) / 3600000)).padStart(2, '0'),
        mm: String(Math.floor((d % 3600000) / 60000)).padStart(2, '0'),
        ss: String(Math.floor((d % 60000) / 1000)).padStart(2, '0'),
      });
    };

    tick(); // Initial call
    const timer = setInterval(tick, 1000);

    return () => clearInterval(timer); // Cleanup: prevents "setting properties of null" on unmount
  }, [game_jam?.sub_end_dt, game_jam?.sub_start_dt, game_jam?.is_upcoming]);

  const GameJamConfig = async () => {
    try {
      let game_jam_config = await makeAPI('/api/gamejam_config', 'post', false, { user_id: user?.user_id });
      // console.log("game_jam_config",game_jam_config)
      if (game_jam_config.status === "S") {
        setgame_jam(game_jam_config?.data);
        setGames(game_jam_config?.games || []);
        setuser_register_stat(game_jam_config?.isRegistered);
      }
    } catch (error) {
      setuser_register_stat(false);
    }
  }

  const formatSubmittedGameTitle = (title, maxChars = 25) => {
    if (!title) return "";
    return title.length > maxChars ? `${title.slice(0, maxChars).trim()}...` : title;
  };

  const socialLinks = [
    { name: "Discord", icon: "fab fa-discord", href: "https://discord.com/invite/SqbByMnDTv", color: "#5865F2" },
    { name: "Instagram", icon: "fab fa-instagram", href: "https://www.instagram.com/cges.club/", color: "#E1306C" },
    { name: "LinkedIn", icon: "fab fa-linkedin-in", href: "https://www.linkedin.com/company/cges-club/", color: "#0A66C2" },
    { name: "YouTube", icon: "fab fa-youtube", href: "https://www.youtube.com/channel/UCuI03JhLpF4Bb6EZ-AWqPfg", color: "#FF0000" },
    { name: "Twitch", icon: "fab fa-twitch", href: "https://www.twitch.tv/cges_club", color: "#9146FF" },
  ];

  return (
    <>
      <style>
        {`
/* ═══════════════════════════════════════════════
   TOKENS
═══════════════════════════════════════════════ */
:root {
  --black:  #080808;
  --dark:   #0f0f0f;
  --dark2:  #161616;
  --dark3:  #1e1e1e;
  --or:     #f97316;
  --or2:    #fb923c;
  --red:    #ef4444;
  --gold:   #f59e0b;
  --silver: #94a3b8;
  --bronze: #b45309;
  --tx:     #ffffff;
  --tx2:    rgba(255,255,255,.7);
  --tx3:    rgba(255,255,255,.4);
  --bd:     rgba(249,115,22,.2);
  --bd2:    rgba(249,115,22,.45);
  --clip-tr: polygon(0 0, calc(100% - 20px) 0, 100% 20px, 100% 100%, 0 100%);
  --clip-bl: polygon(0 0, 100% 0, 100% 100%, 20px 100%, 0 calc(100% - 20px));
  --clip-both: polygon(0 0, calc(100% - 16px) 0, 100% 16px, 100% 100%, 16px 100%, 0 calc(100% - 16px));
}
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
html { scroll-behavior: smooth; }
body { background: var(--black); color: var(--tx); font-family: 'Barlow', sans-serif; overflow-x: hidden; }

/* grain */
body::before {
  content: ''; position: fixed; inset: 0; z-index: 9999; pointer-events: none; opacity: .025;
  background: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E") repeat;
  background-size: 180px;
}


/* ═══════════════════════════════════════════════
   HERO — FULL CINEMATIC BANNER
═══════════════════════════════════════════════ */
.hero {
  position: relative; min-height: 90vh; overflow: hidden;
  display: flex; flex-direction: column; justify-content: flex-end;
  padding: 48px 0 80px;
}

/* Static background image */
.hero-bg-img {
  position: absolute; inset: 0; z-index: 0;
  background-image:
    url('https://images.unsplash.com/photo-1616588589676-62b3bd4ff6d2?w=1920&q=90&auto=format&fit=crop');
  background-size: cover; background-position: center 30%;
  animation: bgZoom 22s ease-in-out infinite alternate;
}
@keyframes bgZoom {
  0%   { transform: scale(1.0); }
  100% { transform: scale(1.07); }
}

/* Overlays */
.hero-ov1 {
  position: absolute; inset: 0; z-index: 2; pointer-events: none;
  background:
    linear-gradient(0deg, rgba(8,8,8,1) 0%, rgba(8,8,8,.82) 28%, rgba(8,8,8,.35) 58%, rgba(8,8,8,.1) 100%),
    linear-gradient(90deg, rgba(8,8,8,.9) 0%, rgba(8,8,8,.4) 45%, rgba(8,8,8,.1) 100%);
}
.hero-ov2 {
  position: absolute; inset: 0; z-index: 3; pointer-events: none;
  background: radial-gradient(ellipse 55% 75% at 8% 65%, rgba(249,115,22,.12) 0%, transparent 65%);
}
.hero-scanlines {
  position: absolute; inset: 0; z-index: 4; pointer-events: none;
  background: repeating-linear-gradient(0deg, transparent, transparent 3px, rgba(0,0,0,.07) 3px, rgba(0,0,0,.07) 4px);
}
.hero-grid-ov {
  position: absolute; inset: 0; z-index: 4; pointer-events: none;
  background-image:
    repeating-linear-gradient(90deg, transparent, transparent 99px, rgba(249,115,22,.03) 99px, rgba(249,115,22,.03) 100px),
    repeating-linear-gradient(0deg, transparent, transparent 99px, rgba(249,115,22,.03) 99px, rgba(249,115,22,.03) 100px);
}

/* Diagonal bottom cut */
.hero::after {
  content: ''; position: absolute; bottom: -1px; left: 0; right: 0; height: 80px; z-index: 6;
  background: var(--black);
  clip-path: polygon(0 100%, 100% 100%, 100% 0);
}

/* Two-column hero layout */
.hero-body {
  position: relative; z-index: 5;
  display: grid; grid-template-columns: minmax(0, 1fr) minmax(280px, 360px);
  gap: clamp(24px, 3vw, 48px); align-items: end;
  padding: 0 clamp(24px, 5vw, 80px); max-width: 1400px; width: 100%;
}

/* Left content */
.hero-content { /* no change needed — inherits from parent */ }

.hero-content { min-width: 0; }

/* Live badge */
.hero-live {
  display: inline-flex; align-items: center; gap: 8px;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 11px; letter-spacing: 3px; text-transform: uppercase;
  color: #22c55e; margin-bottom: 24px;
  background: rgba(34,197,94,.1); border: 1px solid rgba(34,197,94,.3);
  padding: 6px 16px; border-radius: 2px; width: fit-content;
  animation: fadeUp .6s ease both;
}
.live-dot {
  width: 6px; height: 6px; border-radius: 50%; background: #22c55e;
  animation: pdot 1.5s ease-in-out infinite;
}

/* Giant headline */
.hero-tag {
  display: block;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
  font-size: clamp(13px, 1.5vw, 18px); letter-spacing: 8px;
  text-transform: uppercase; color: var(--or);
  margin-bottom: 8px; animation: fadeUp .6s .1s ease both;
}
.hero-h1 {
  font-family: 'Jersey 25', monospace;
  line-height: 1; letter-spacing: 2px;
  margin-bottom: 12px; animation: fadeUp .6s .15s ease both;
}
.hero-h1 .line1 {
  display: block; font-size: clamp(60px, 9vw, 120px);
  color: var(--tx);
}
.hero-h1 .line2 {
  display: block; font-size: clamp(48px, 8vw, 108px);
  color: transparent;
  -webkit-text-stroke: 2px var(--or);
  text-shadow: 0 0 60px rgba(249,115,22,.4), 0 0 120px rgba(249,115,22,.15);
  animation: fadeUp .6s .2s ease both, neonFlicker 6s 3s infinite;
}
@keyframes neonFlicker {
  0%,96%,100%{ -webkit-text-stroke-color: var(--or); opacity:1; }
  97%{ opacity:.7; -webkit-text-stroke-color: rgba(249,115,22,.4); }
  98%{ opacity:1; -webkit-text-stroke-color: var(--or); }
  99%{ opacity:.5; -webkit-text-stroke-color: rgba(249,115,22,.3); }
}

.hero-sub {
  font-size: clamp(15px, 1.5vw, 18px); color: var(--tx2); line-height: 1.7;
  max-width: 560px; margin-bottom: clamp(22px, 4vw, 40px);
  animation: fadeUp .6s .25s ease both;
}
.hero-sub strong { color: var(--or); font-weight: 600; }

/* CTA row */
.hero-actions {
  display: flex; align-items: center; gap: 16px; flex-wrap: wrap;
  margin-bottom: clamp(24px, 5vw, 56px); animation: fadeUp .6s .3s ease both;
}
.btn-hero {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
  font-size: 15px; letter-spacing: 3px; text-transform: uppercase;
  padding: 16px 44px; cursor: pointer; text-decoration: none;
  display: inline-flex; align-items: center; gap: 10px; transition: all .25s;
}
.btn-hero.primary {
  background: var(--or); color: #fff;
  clip-path: var(--clip-both);
}
.btn-hero.primary:hover {
  background: var(--or2); transform: translateY(-2px);
  box-shadow: 0 8px 40px rgba(249,115,22,.55), 0 0 80px rgba(249,115,22,.2);
}
.btn-hero.ghost {
  background: transparent; color: var(--tx);
  border: 1px solid rgba(255,255,255,.25);
  clip-path: var(--clip-both);
}
.btn-hero.ghost:hover { border-color: rgba(255,255,255,.6); background: rgba(255,255,255,.06); }
.btn-arrow { font-size: 18px; }

/* Hero stats strip */
.hero-stats {
  display: flex; align-items: stretch; gap: 0;
  animation: fadeUp .6s .38s ease both;
}
.hstat {
  padding: clamp(12px, 2vw, 16px) clamp(18px, 2vw, 32px); border-left: 2px solid rgba(249,115,22,.3);
  position: relative;
}
.hstat:first-child { padding-left: 0; border-left: none; }
.hstat:first-child::before { display: none; }
.hstat-val {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
  font-size: clamp(24px, 2.4vw, 32px); color: var(--or); line-height: 1; letter-spacing: -1px;
  display: block;
}
.hstat-lbl {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 600;
  font-size: 11px; letter-spacing: 2px; text-transform: uppercase;
  color: var(--tx3); margin-top: 3px; display: block;
}

/* ─── COUNTDOWN — inline right column ─── */
.hero-countdown {
  background: rgba(8,8,8,.82); backdrop-filter: blur(20px);
  border: 1px solid var(--bd2); padding: clamp(18px, 2vw, 28px) clamp(16px, 2vw, 24px);
  clip-path: polygon(0 0, calc(100% - 16px) 0, 100% 16px, 100% 100%, 0 100%);
  animation: fadeUp .6s .4s ease both;
  position: relative;
}
.hero-side-panel {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: min(100%, 360px);
  justify-self: end;
}
.hero-countdown::before {
  content: ''; position: absolute; top: 0; left: 0; right: 0; height: 2px;
  background: linear-gradient(90deg, var(--or), transparent);
}
.cd-top {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 16px;
}
.cd-title {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 11px; letter-spacing: 3px; text-transform: uppercase; color: var(--or);
}
.cd-status {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 10px; letter-spacing: 2px; text-transform: uppercase;
  color: #22c55e; background: rgba(34,197,94,.1);
  border: 1px solid rgba(34,197,94,.25); padding: 3px 10px; border-radius: 2px;
}
.cd-grid {
  display: grid; grid-template-columns: repeat(4,1fr); gap: 8px; margin-bottom: 16px;
}
.cd-box {
  background: rgba(249,115,22,.06); border: 1px solid var(--bd);
  text-align: center; padding: 12px 6px 10px; border-radius: 2px;
}
.cd-num {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
  font-size: clamp(28px, 2.7vw, 38px); line-height: 1; color: var(--tx); display: block; letter-spacing: -1px;
}
.cd-lbl {
  font-family: 'Barlow Condensed', sans-serif; font-size: 9px; letter-spacing: 2px;
  text-transform: uppercase; color: var(--tx3); margin-top: 4px; display: block;
}
.cd-ended {
  border: 1px dashed var(--bd2);
  background: rgba(249,115,22,.08);
  padding: 18px 10px;
  text-align: center;
  font-family: 'Barlow Condensed', sans-serif;
  font-weight: 800;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: var(--or);
  margin-bottom: 16px;
}


/* ─── FLOATING SCROLL INDICATOR ─── */
.support-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-height: 54px;
  padding: 14px 16px;
  background: linear-gradient(135deg, rgba(88,101,242,.18), rgba(8,8,8,.92));
  border: 1px solid rgba(88,101,242,.45);
  color: #fff;
  text-decoration: none;
  clip-path: var(--clip-both);
  transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease, background .25s ease;
  animation: fadeUp .6s .48s ease both;
}
.support-btn:hover {
  transform: translateY(-2px);
}
.discord-support-btn {
  background: linear-gradient(135deg, rgba(88,101,242,.18), rgba(8,8,8,.92));
  border: 1px solid rgba(88,101,242,.45);
}
.discord-support-btn:hover {
  border-color: rgba(88,101,242,.8);
  box-shadow: 0 14px 34px rgba(88,101,242,.22);
  background: linear-gradient(135deg, rgba(88,101,242,.28), rgba(8,8,8,.96));
}
.email-support-btn {
  background: linear-gradient(135deg, rgba(249,115,22,.18), rgba(8,8,8,.92));
  border: 1px solid rgba(249,115,22,.4);
}
.email-support-btn:hover {
  border-color: rgba(249,115,22,.75);
  box-shadow: 0 14px 34px rgba(249,115,22,.18);
  background: linear-gradient(135deg, rgba(249,115,22,.28), rgba(8,8,8,.96));
}
.support-icon {
  font-size: 20px;
}
.discord-support-icon {
  color: #8ea1ff;
}
.email-support-icon {
  color: #ffb16a;
}
.support-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.support-kicker {
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: rgba(255,255,255,.6);
}
.support-label {
  font-family: 'Barlow Condensed', sans-serif;
  font-size: clamp(14px, 1.4vw, 16px);
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #fff;
}
.scroll-hint {
  position: absolute; bottom: 20px; left: 50%; transform: translateX(-50%);
  z-index: 5; display: flex; flex-direction: column; align-items: center; gap: 6px;
  animation: bobble 2s ease-in-out infinite;
}
@keyframes bobble { 0%,100%{transform:translateX(-50%) translateY(0)} 50%{transform:translateX(-50%) translateY(8px)} }
.scroll-hint span {
  font-family: 'Barlow Condensed', sans-serif; font-size: 10px; letter-spacing: 3px;
  text-transform: uppercase; color: var(--tx3);
}
.scroll-arrow { width: 20px; height: 20px; border-right: 2px solid var(--or); border-bottom: 2px solid var(--or); transform: rotate(45deg); opacity: .6; }

@keyframes fadeUp { from{opacity:0;transform:translateY(28px)} to{opacity:1;transform:none} }

/* ═══════════════════════════════════════════════
   SECTION SHARED
═══════════════════════════════════════════════ */
.section { padding: 96px 80px; }
.si { max-width: 1280px; margin: 0 auto; }

.sec-eyebrow {
  display: flex; align-items: center; gap: 12px;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 11px; letter-spacing: 4px; text-transform: uppercase;
  color: var(--or); margin-bottom: 12px;
}
.sec-eyebrow::before { content: ''; width: 28px; height: 2px; background: var(--or); }

.sec-title {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
  font-size: clamp(28px, 4vw, 52px); letter-spacing: .5px;
  text-transform: uppercase; line-height: 1.0; color: var(--tx);
}
.sec-title .hl { color: var(--or); }
.sec-title .stroke {
  color: transparent; -webkit-text-stroke: 1.5px var(--or);
}

.sec-divider {
  width: 64px; height: 3px; margin: 16px 0 52px;
  background: linear-gradient(90deg, var(--or), rgba(249,115,22,.2));
}

/* ═══════════════════════════════════════════════
   GAMES GRID
═══════════════════════════════════════════════ */
.games-sec {
  background: var(--dark); position: relative; overflow: hidden;
  padding: 80px 80px 96px;
}
.games-sec::before {
  content: ''; position: absolute; inset: 0; z-index: 0; pointer-events: none;
  background:
    radial-gradient(ellipse 60% 50% at 50% 0%, rgba(249,115,22,.06) 0%, transparent 65%),
    repeating-linear-gradient(90deg, transparent, transparent 119px, rgba(249,115,22,.03) 119px, rgba(249,115,22,.03) 120px);
}
.games-header {
  display: flex; align-items: flex-end; justify-content: space-between;
  margin-bottom: 40px; position: relative; z-index: 1;
}
.games-filter {
  display: flex; gap: 6px; align-items: center;
}
.gf-btn {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 11px; letter-spacing: 2px; text-transform: uppercase;
  padding: 7px 16px; cursor: pointer; transition: all .2s;
  background: transparent; border: 1px solid rgba(255,255,255,.1); color: var(--tx3);
}
.gf-btn.active, .gf-btn:hover {
  background: var(--or); color: #fff; border-color: var(--or);
}

/* 5-column grid with proper card spacing */
.games-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, 220px);
  gap: 20px;
  justify-content: center;
  align-items: start;
  position: relative; z-index: 1;
}

/* Card — thumbnail on top, info below */
.game-card {
  width: 220px;
  background: var(--dark2);
  border: 1px solid rgba(255,255,255,.09);
  border-radius: 8px;
  cursor: pointer;
  transition: transform .3s ease, border-color .3s ease, box-shadow .3s ease;
  display: flex; flex-direction: column;
  overflow: hidden;
}
.game-card:hover {
  transform: translateY(-7px);
  border-color: rgba(249,115,22,.5);
  box-shadow: 0 16px 48px rgba(0,0,0,.6), 0 0 0 1px rgba(249,115,22,.25);
  z-index: 2;
}
.game-card:hover .gc-thumb-img { transform: scale(1.07); filter: brightness(.8) saturate(1.4); }
.game-card:hover .gc-play-btn { opacity: 1; transform: translate(-50%,-50%) scale(1); }

/* Thumbnail wrapper — landscape 16:10 like game thumbnails */
.gc-thumb {
  position: relative;
  width: 100%; aspect-ratio: 16 / 10;
  overflow: hidden; flex-shrink: 0;
  border-radius: 0;
}
.gc-thumb-img {
  position: absolute; inset: 0; width: 100%; height: 100%;
  object-fit: cover; display: block;
  transition: transform .4s ease, filter .4s ease;
  filter: brightness(.95) saturate(1.1);
}

/* Top badges row over thumbnail */
.gc-top {
  position: absolute; top: 8px; left: 8px; right: 8px;
  display: flex; justify-content: space-between; align-items: flex-start; z-index: 3;
}
.gc-rank {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
  font-size: 10px; letter-spacing: 2px; text-transform: uppercase;
  background: var(--or); color: #080808; padding: 3px 9px;
  clip-path: polygon(4px 0%,100% 0%,calc(100% - 4px) 100%,0% 100%);
}
.gc-rank.r2  { background: var(--silver); color: #080808; }
.gc-rank.r3  { background: #cd7c2f; color: #080808; }
.gc-rank.rnew { background: #22c55e; color: #080808; }
.gc-status {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 9px; letter-spacing: 2px; text-transform: uppercase;
  background: rgba(8,8,8,.75); border: 1px solid rgba(255,255,255,.18);
  color: var(--tx2); padding: 3px 7px;
}

/* Centered play button appears on hover */
.gc-play-btn {
  position: absolute; top: 50%; left: 50%;
  transform: translate(-50%,-50%) scale(.8);
  z-index: 4; opacity: 0;
  transition: opacity .22s ease, transform .22s ease;
  width: 48px; height: 48px; border-radius: 50%;
  background: var(--or); border: none; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 0 0 6px rgba(249,115,22,.25), 0 0 28px rgba(249,115,22,.6);
}
.gc-play-btn::before {
  content: ''; width: 0; height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 14px solid #080808;
  margin-left: 3px;
}
/* dim overlay on thumbnail when hovering */
.gc-thumb::after {
  content: ''; position: absolute; inset: 0;
  background: rgba(8,8,8,.35);
  opacity: 0; transition: opacity .3s;
  z-index: 2;
}
.game-card:hover .gc-thumb::after { opacity: 1; }

/* Info section — below thumbnail */
.gc-info {
  padding: 12px 14px 16px;
  display: flex; flex-direction: column; gap: 8px;
  flex: 1; background: var(--dark2);
}
.gc-name {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 800;
  font-size: 12px; text-transform: uppercase; letter-spacing: .4px;
  color: var(--tx); line-height: 1.2;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.gc-meta {
  display: flex; align-items: center; justify-content: space-between; gap: 8px;
}
.gc-votes {
  display: flex; align-items: center; gap: 5px;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 12px; letter-spacing: 1px; color: var(--or);
}
.gc-votes-icon { font-size: 11px; }
.gc-tag {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 9px; letter-spacing: 1.5px; text-transform: uppercase;
  padding: 2px 8px; border-radius: 1px;
}
.gt-a  { background: rgba(249,115,22,.15); color: var(--or2); }
.gt-p  { background: rgba(79,172,254,.12); color: #7dd3fc; }
.gt-pl { background: rgba(52,211,153,.12); color: #6ee7b7; }
.gt-v  { background: rgba(167,139,250,.12); color: #c4b5fd; }
.gt-ar { background: rgba(251,113,133,.12); color: #fda4af; }

/* Play button in info row */
.gc-play-row {
  display: flex; align-items: center; gap: 8px; margin-top: 4px;
}
.gc-play-full {
  flex: 1;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 800;
  font-size: 11px; letter-spacing: 2px; text-transform: uppercase;
  background: var(--or); color: #fff;
  border: none; padding: 8px 0; cursor: pointer;
  transition: all .2s; display: flex; align-items: center; justify-content: center; gap: 6px;
  clip-path: polygon(5px 0%,100% 0%,calc(100% - 5px) 100%,0% 100%);
}
.gc-play-full:hover {  box-shadow: 0 0 16px rgba(249,115,22,.5);color:#FFF; }
.gc-play-full .play-arrow {
  width: 0; height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 9px solid #080808;
}
.gc-vote-btn {
  min-width: 42px; height: 34px; flex-shrink: 0;
  padding: 0 8px;
  background: transparent; border: 1px solid rgba(249,115,22,.3);
  color: var(--or); cursor: default; transition: all .2s;
  display: flex; align-items: center; justify-content: center; gap: 4px;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 12px; letter-spacing: .4px;
}
// .gc-vote-btn:hover { background: rgba(249,115,22,.12); border-color: var(--or); }

/* View all button */
.games-footer {
  display: flex; justify-content: center; margin-top: 40px; position: relative; z-index: 1;
}

/* ═══════════════════════════════════════════════
   ABOUT / CHALLENGE STRIP
═══════════════════════════════════════════════ */
.about-sec { background: var(--dark); position: relative; overflow: hidden; }
.about-sec::before {
  content: ''; position: absolute; top: 0; left: 0; right: 0; height: 4px;
  background: linear-gradient(90deg, var(--or), var(--red), var(--or));
  animation: borderFlow 3s linear infinite; background-size: 200% 100%;
}
@keyframes borderFlow { 0%{background-position:0 0}100%{background-position:200% 0} }

.about-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: start; }

.about-text .lead {
  font-size: 18px; line-height: 1.8; color: var(--tx2); margin-top: 28px; margin-bottom: 32px;
}
.about-text .lead strong { color: var(--tx); }
.feat-list { list-style: none; display: flex; flex-direction: column; gap: 12px; }
.feat-list li {
  display: flex; align-items: center; gap: 12px;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 600;
  font-size: 15px; letter-spacing: 1px; color: var(--tx2);
}
.feat-list li::before {
  content: ''; width: 6px; height: 6px; background: var(--or);
  flex-shrink: 0; transform: rotate(45deg);
  box-shadow: 0 0 6px var(--or);
}

.cards-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.info-card {
  background: var(--dark2); border: 1px solid rgba(255,255,255,.07);
  padding: 24px 20px; position: relative; overflow: hidden;
  transition: all .25s; cursor: default;
  clip-path: polygon(0 0, calc(100% - 12px) 0, 100% 12px, 100% 100%, 0 100%);
}
.info-card::before {
  content: ''; position: absolute; top: 0; left: 0; right: 0; height: 2px;
  background: var(--card-c, var(--or)); transform: scaleX(0); transform-origin: left; transition: transform .3s;
}
.info-card:hover { border-color: rgba(249,115,22,.25); transform: translateY(-3px); }
.info-card:hover::before { transform: scaleX(1); }
.ic-icon { font-size: 28px; margin-bottom: 12px; display: block; }
.ic-title {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 800;
  font-size: 16px; text-transform: uppercase; letter-spacing: .5px; margin-bottom: 6px;
}
.ic-text { font-size: 13px; color: var(--tx3); line-height: 1.6; }
.ic-badge {
  display: inline-block; margin-top: 12px;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 10px; letter-spacing: 2px; text-transform: uppercase;
  background: rgba(249,115,22,.1); color: var(--or);
  border: 1px solid rgba(249,115,22,.2); padding: 3px 10px; border-radius: 1px;
}

/* ═══════════════════════════════════════════════
   GAME IDEAS — HORIZONTAL SCROLL CARDS
═══════════════════════════════════════════════ */
.ideas-sec { background: var(--black); }
.ideas-scroll {
  display: grid; grid-template-columns: minmax(0, 1.5fr) minmax(280px, .9fr);
  gap: 18px; margin-top: 52px; align-items: stretch;
}
.idea-spotlight {
  position: relative; overflow: hidden;
  background:
    radial-gradient(circle at top right, rgba(79,172,254,.18), transparent 34%),
    linear-gradient(135deg, rgba(249,115,22,.14), rgba(255,255,255,.02)),
    var(--dark2);
  border: 1px solid rgba(255,255,255,.08);
  padding: 34px 34px 30px;
  min-height: 100%;
}
.idea-spotlight::after {
  content: '';
  position: absolute; inset: 0;
  background: linear-gradient(180deg, transparent 45%, rgba(249,115,22,.08) 100%);
  pointer-events: none;
}
.idea-topline {
  display: flex; align-items: center; justify-content: space-between; gap: 16px;
  margin-bottom: 24px; position: relative; z-index: 1;
}
.idea-number {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
  font-size: 66px; color: rgba(249,115,22,.12); line-height: .9;
  letter-spacing: -2px;
}
.idea-chip {
  display: inline-flex; align-items: center; gap: 8px;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 10px; letter-spacing: 2px; text-transform: uppercase;
  padding: 6px 12px; border-radius: 999px;
  border: 1px solid transparent;
}
.idea-head {
  position: relative; z-index: 1;
  display: flex; align-items: flex-start; gap: 18px; margin-bottom: 18px;
}
.idea-icon {
  width: 72px; height: 72px; flex: 0 0 72px;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 30px; border-radius: 20px;
  background: rgba(249,115,22,.12);
  border: 1px solid rgba(249,115,22,.22);
}
.idea-label {
  font-family: 'Barlow Condensed', sans-serif; font-size: 12px;
  font-weight: 700; letter-spacing: 3px; text-transform: uppercase;
  color: var(--or); margin-bottom: 8px;
}
.idea-title {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 800;
  font-size: 38px; line-height: .95; text-transform: uppercase;
  letter-spacing: .5px; margin: 0;
}
.idea-desc {
  position: relative; z-index: 1;
  font-size: 15px; color: var(--tx2); line-height: 1.75;
  max-width: 740px; margin-bottom: 22px;
}
.idea-points {
  position: relative; z-index: 1;
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px;
}
.idea-point {
  background: rgba(255,255,255,.03);
  border: 1px solid rgba(255,255,255,.06);
  padding: 16px 16px 14px;
}
.idea-point-k {
  display: block; margin-bottom: 6px;
  font-family: 'Barlow Condensed', sans-serif; font-size: 11px;
  font-weight: 700; letter-spacing: 2px; text-transform: uppercase;
  color: var(--tx3);
}
.idea-point-v {
  display: block;
  font-family: 'Barlow Condensed', sans-serif; font-size: 19px;
  font-weight: 800; line-height: 1.2; text-transform: uppercase;
  color: var(--tx);
}
.idea-stack {
  display: grid; gap: 14px;
}
.idea-card {
  background: var(--dark2); border: 1px solid rgba(255,255,255,.06);
  padding: 22px 20px; position: relative; overflow: hidden;
  transition: all .3s; cursor: default;
}
.idea-card::after {
  content: '';
  position: absolute; inset: 0;
  background: linear-gradient(180deg, transparent 40%, rgba(249,115,22,.05) 100%);
  opacity: 0; transition: opacity .3s;
}
.idea-card:hover { border-color: var(--bd); transform: translateY(-6px); }
.idea-card:hover::after { opacity: 1; }
.idea-mini-title {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 800;
  font-size: 18px; text-transform: uppercase; letter-spacing: .5px;
  margin: 14px 0 8px; color: var(--tx);
}
.idea-mini-desc { font-size: 13px; color: var(--tx3); line-height: 1.6; margin-bottom: 0; }
.ic-p  { background: rgba(79,172,254,.1); color: #7dd3fc; border-color: rgba(79,172,254,.18); }
.ic-or { background: rgba(249,115,22,.12); color: var(--or2); border-color: rgba(249,115,22,.2); }
.ic-gr { background: rgba(52,211,153,.1); color: #6ee7b7; border-color: rgba(52,211,153,.18); }
.ic-v  { background: rgba(167,139,250,.1); color: #c4b5fd; border-color: rgba(167,139,250,.18); }

/* ═══════════════════════════════════════════════
   RULES
═══════════════════════════════════════════════ */
.rules-sec { background: var(--dark); position: relative; }
.rules-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; margin-top: 52px; }
.rules-col-head {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 800;
  font-size: 13px; letter-spacing: 3px; text-transform: uppercase;
  padding: 12px 0 12px 16px; margin-bottom: 16px;
  border-left: 3px solid;
}
.rules-col-head.ok  { color: #22c55e; border-color: #22c55e; }
.rules-col-head.bad { color: var(--red); border-color: var(--red); }
.rule-item {
  display: flex; gap: 14px; align-items: baseline; padding: 14px 16px;
  margin-bottom: 8px; background: var(--dark2); border: 1px solid rgba(255,255,255,.05);
  transition: border-color .2s;
}
.rule-item:hover { border-color: rgba(249,115,22,.2); }
.ri-ico { font-size: 15px; flex-shrink: 0; line-height: 1; }
.ri-text { font-size: 14px; color: var(--tx2); line-height: 1.55; }
.ri-text strong { color: var(--tx); font-weight: 600; }

/* ═══════════════════════════════════════════════
   TIMELINE — 3 PHASE SIMPLIFIED
═══════════════════════════════════════════════ */
.tl-sec { background: var(--black); }

/* Phase bar track */
.tl-bar-wrap { margin-top: 56px; position: relative; }

/* Progress bar */
.tl-progress {
  position: relative; height: 6px;
  background: rgba(255,255,255,.07);
  border-radius: 3px; margin-bottom: 0;
  overflow: visible;
}
.tl-progress-fill {
  position: absolute; left: 0; top: 0; height: 100%;
  width: 99.3%;
  background: linear-gradient(90deg, var(--or), var(--or2));
  border-radius: 3px;
  box-shadow: 0 0 12px rgba(249,115,22,.6);
}

/* Phase markers on bar */
.tl-markers {
  position: relative; display: flex;
  justify-content: space-between;
  margin-top: -9px;
}
.tl-mark {
  width: 12px; height: 12px; border-radius: 50%;
  background: var(--dark); border: 2px solid rgba(255,255,255,.2);
  transform: translateX(-50%);
  position: relative; z-index: 2;
  transition: all .25s;
}
.tl-mark.done { background: var(--or); border-color: var(--or); box-shadow: 0 0 14px rgba(249,115,22,.6); }
.tl-mark.current {
  background: var(--or); border-color: var(--or);
  box-shadow: 0 0 0 4px rgba(249,115,22,.25), 0 0 20px rgba(249,115,22,.5);
  animation: markPulse 2s ease-in-out infinite;
}
@keyframes markPulse { 0%,100%{box-shadow:0 0 0 4px rgba(249,115,22,.25),0 0 20px rgba(249,115,22,.5)} 50%{box-shadow:0 0 0 8px rgba(249,115,22,.1),0 0 30px rgba(249,115,22,.7)} }
.tl-mark.future { background: var(--dark2); border-color: rgba(255,255,255,.15); }

/* 3 phase cards below bar */
.tl-phases {
  display: grid; grid-template-columns: repeat(3,1fr);
  gap: 16px; margin-top: 32px;
}
.tl-phase {
  background: var(--dark2); border: 1px solid rgba(255,255,255,.07);
  padding: 28px 24px; position: relative; overflow: hidden;
  transition: border-color .25s, transform .25s;
}
.tl-phase:hover { border-color: rgba(249,115,22,.3); transform: translateY(-3px); }
.tl-phase::before {
  content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px;
  background: var(--ph-c, rgba(255,255,255,.1));
}
.tl-phase.ph-active { border-color: rgba(249,115,22,.35); }
.tl-phase.ph-active::before { background: var(--or); box-shadow: 0 0 12px rgba(249,115,22,.4); }
.tl-phase.ph-upcoming::before { background: rgba(255,255,255,.15); }

.ph-range {
  font-family: 'Jersey 25', monospace; font-size: 28px; letter-spacing: 1px;
  color: var(--ph-col, var(--tx3)); display: block; margin-bottom: 10px;
  line-height: 1;
}
.tl-phase.ph-active .ph-range { color: var(--or); text-shadow: 0 0 20px rgba(249,115,22,.4); }
.tl-phase.ph-voting .ph-range { color: #60a5fa; text-shadow: 0 0 20px rgba(96,165,250,.3); }
.tl-phase.ph-upcoming .ph-range { color: #22c55e; text-shadow: 0 0 20px rgba(34,197,94,.3); }

.ph-label {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
  font-size: 20px; text-transform: uppercase; letter-spacing: 1px;
  color: var(--tx); margin-bottom: 4px; display: block;
}
.ph-sub {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 600;
  font-size: 11px; letter-spacing: 3px; text-transform: uppercase;
  color: var(--tx3); margin-bottom: 16px; display: block;
}
.ph-desc { font-size: 13px; color: var(--tx3); line-height: 1.65; margin-bottom: 16px; }
.ph-badge {
  display: inline-flex; align-items: center; gap: 6px;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 10px; letter-spacing: 2px; text-transform: uppercase;
  padding: 5px 14px;
  border: 1px solid var(--ph-bc, rgba(255,255,255,.1));
  color: var(--ph-tc, var(--tx3));
}
.ph-badge.ph-badge-corner {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
}
.tl-phase.ph-active .ph-badge   { border-color: rgba(249,115,22,.4); color: var(--or); background: rgba(249,115,22,.08); }
.tl-phase.ph-voting .ph-badge   { border-color: rgba(96,165,250,.35); color: #60a5fa; background: rgba(96,165,250,.08); }
.tl-phase.ph-upcoming .ph-badge { border-color: rgba(34,197,94,.35); color: #22c55e; background: rgba(34,197,94,.08); }
.ph-badge-dot {
  width: 6px; height: 6px; border-radius: 50%;
  background: currentColor; animation: pdot 1.8s ease-in-out infinite;
}

/* Phase icons */
.ph-icon {
  font-size: 32px; display: block; margin-bottom: 16px;
}

/* Steps list inside each phase */
.ph-steps { list-style: none; display: flex; flex-direction: column; gap: 8px; margin-top: 12px; border-top: 1px solid rgba(255,255,255,.06); padding-top: 16px; }
.ph-steps li {
  display: flex; align-items: flex-start; gap: 10px;
  font-size: 13px; color: var(--tx2); line-height: 1.5;
}
.ph-steps li::before {
  content: ''; width: 5px; height: 5px; min-width: 5px; margin-top: 5px;
  transform: rotate(45deg); flex-shrink: 0;
}
.tl-phase.ph-active .ph-steps li::before   { background: var(--or); }
.tl-phase.ph-voting .ph-steps li::before   { background: #60a5fa; }
.tl-phase.ph-upcoming .ph-steps li::before { background: #22c55e; }


/* ═══════════════════════════════════════════════
   PRIZES — FULL GAMING REDESIGN
═══════════════════════════════════════════════ */
.prizes-sec {
  background: var(--black); position: relative; overflow: hidden;
}
/* animated bg grid */
.prizes-sec::before {
  content: ''; position: absolute; inset: 0; z-index: 0; pointer-events: none;
  background-image:
    repeating-linear-gradient(90deg, transparent, transparent 79px, rgba(249,115,22,.04) 79px, rgba(249,115,22,.04) 80px),
    repeating-linear-gradient(0deg, transparent, transparent 79px, rgba(249,115,22,.04) 79px, rgba(249,115,22,.04) 80px);
  animation: pgrid 15s linear infinite;
}
@keyframes pgrid { 0%{background-position:0 0,0 0} 100%{background-position:80px 80px,80px 80px} }
/* corner accent glows */
.prizes-sec::after {
  content: ''; position: absolute; inset: 0; z-index: 0; pointer-events: none;
  background:
    radial-gradient(ellipse 50% 60% at 50% 110%, rgba(249,115,22,.1) 0%, transparent 70%),
    radial-gradient(ellipse 30% 40% at 0% 50%, rgba(239,68,68,.05) 0%, transparent 60%),
    radial-gradient(ellipse 30% 40% at 100% 50%, rgba(249,115,22,.05) 0%, transparent 60%);
}

/* ── Prize pool total bar ── */
.prize-total-bar {
  display: flex; align-items: center; gap: 24px;
  margin-bottom: 56px; padding: 20px 28px;
  background: rgba(249,115,22,.06);
  border: 1px solid rgba(249,115,22,.25);
  border-left: 4px solid var(--or);
  position: relative; z-index: 1;
}
.ptb-label {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 11px; letter-spacing: 4px; text-transform: uppercase; color: var(--tx3);
}
.ptb-val {
  font-family: 'Jersey 25', monospace; font-size: 28px; color: var(--or);
  text-shadow: 0 0 20px rgba(249,115,22,.5); letter-spacing: 2px;
}
.ptb-sep { width: 1px; height: 32px; background: rgba(249,115,22,.2); }
.ptb-note { font-family: 'Barlow Condensed', sans-serif; font-size: 13px; color: var(--tx3); letter-spacing: 1px; }

/* ── Main prize cards ── */
.prize-arena {
  display: grid; grid-template-columns: 1fr 1.1fr 1fr;
  gap: 2px; margin-bottom: 2px; position: relative; z-index: 1;
  align-items: end;
}

.pz-card {
  position: relative; overflow: hidden;
  background: var(--dark2);
  transition: transform .3s ease;
  cursor: default;
}
.pz-card:hover { transform: translateY(-8px); z-index: 2; }

/* card inner padding */
.pz-inner { padding: 36px 28px 32px; position: relative; z-index: 2; }

/* top accent line */
.pz-card::before {
  content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px;
  background: var(--pz-color, var(--or)); z-index: 3;
}
/* bottom height bar */
.pz-card::after {
  content: ''; position: absolute; bottom: 0; left: 0; right: 0;
  height: var(--pz-h, 6px); background: var(--pz-color, var(--or));
  opacity: .35;
}

/* 1st place — gold */
.pz-first {
  --pz-color: var(--or); --pz-h: 8px;
  background: linear-gradient(180deg, rgba(249,115,22,.1) 0%, rgba(249,115,22,.03) 40%, var(--dark2) 100%);
  border: 1px solid rgba(249,115,22,.4);
  box-shadow: 0 0 60px rgba(249,115,22,.12), inset 0 0 40px rgba(249,115,22,.04);
}
/* animated scan on first card */
.pz-first .pz-scan {
  position: absolute; inset: 0; z-index: 1; pointer-events: none;
  background: repeating-linear-gradient(0deg, transparent, transparent 3px, rgba(249,115,22,.02) 3px, rgba(249,115,22,.02) 4px);
}
.pz-first .pz-sweep {
  position: absolute; left: 0; right: 0; height: 60px;
  background: linear-gradient(180deg, transparent, rgba(249,115,22,.06), transparent);
  animation: sweep 3s ease-in-out infinite; z-index: 1; pointer-events: none;
}
@keyframes sweep { 0%{top:-60px} 100%{top:calc(100% + 60px)} }

/* 2nd place — silver */
.pz-second {
  --pz-color: var(--silver); --pz-h: 6px;
  border: 1px solid rgba(148,163,184,.2);
}
/* 3rd place — bronze */
.pz-third {
  --pz-color: #cd7c2f; --pz-h: 4px;
  border: 1px solid rgba(205,124,47,.2);
}

/* rank badge top */
.pz-rank-badge {
  display: inline-flex; align-items: center; gap: 8px;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 10px; letter-spacing: 3px; text-transform: uppercase;
  padding: 5px 12px; margin-bottom: 20px;
  border: 1px solid var(--pz-color, var(--or));
  color: var(--pz-color, var(--or));
  background: rgba(0,0,0,.4);
  clip-path: polygon(6px 0%,100% 0%,calc(100% - 6px) 100%,0% 100%);
}
.pz-rank-dot {
  width: 6px; height: 6px;
  background: var(--pz-color, var(--or));
  transform: rotate(45deg);
}

/* trophy icon */
.pz-trophy {
  display: flex; align-items: center; justify-content: center;
  width: 72px; height: 72px; margin: 0 auto 20px;
  position: relative;
}
.pz-trophy-icon { font-size: 44px; display: block; position: relative; z-index: 1; }
.pz-first .pz-trophy::before {
  content: ''; position: absolute; inset: 0; border-radius: 50%;
  background: radial-gradient(circle, rgba(249,115,22,.3) 0%, transparent 70%);
  animation: trophyPulse 2s ease-in-out infinite;
}
@keyframes trophyPulse { 0%,100%{transform:scale(1);opacity:.8} 50%{transform:scale(1.3);opacity:.3} }

/* place label */
.pz-place {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
  font-size: 11px; letter-spacing: 3px; text-transform: uppercase;
  color: var(--tx3); text-align: center; margin-bottom: 6px; display: block;
}

/* title */
.pz-title {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
  font-size: 20px; letter-spacing: 3px; text-transform: uppercase;
  text-align: center; margin-bottom: 20px; display: block;
  color: var(--pz-color, var(--or));
  clip-path: polygon(8px 0%,100% 0%,calc(100% - 8px) 100%,0% 100%);
  background: rgba(0,0,0,.5);
  padding: 6px 20px;
  border: 1px solid var(--pz-color, var(--or));
}

/* amount */
.pz-amount {
  font-family: 'Jersey 25', monospace;
  font-size: clamp(44px, 5vw, 68px);
  line-height: 1; letter-spacing: 1px;
  text-align: center; display: block; margin-bottom: 4px;
}
.pz-first .pz-amount {
  color: var(--or);
  text-shadow: 0 0 30px rgba(249,115,22,.6), 0 0 60px rgba(249,115,22,.25);
  animation: amtGlow 2.5s ease-in-out infinite;
}
@keyframes amtGlow {
  0%,100%{text-shadow:0 0 30px rgba(249,115,22,.6),0 0 60px rgba(249,115,22,.25)}
  50%{text-shadow:0 0 50px rgba(249,115,22,.9),0 0 100px rgba(249,115,22,.4)}
}
.pz-second .pz-amount { color: var(--silver); text-shadow: 0 0 20px rgba(148,163,184,.3); }
.pz-third  .pz-amount { color: #cd7c2f; text-shadow: 0 0 20px rgba(205,124,47,.3); }

.pz-reward-lbl {
  font-family: 'Barlow Condensed', sans-serif; font-size: 10px;
  letter-spacing: 3px; text-transform: uppercase; color: var(--tx3);
  text-align: center; display: block; margin-bottom: 24px;
}

/* divider */
.pz-divider {
  height: 1px; background: rgba(255,255,255,.08); margin-bottom: 20px;
  position: relative;
}
.pz-divider::after {
  content: ''; position: absolute; left: 0; top: 0; height: 1px; width: 40%;
  background: var(--pz-color, var(--or)); opacity: .5;
}

/* perks list */
.pz-perks { list-style: none; }
.pz-perks li {
  display: flex; align-items: flex-start; gap: 10px;
  font-size: 13px; color: var(--tx2); padding: 6px 0;
  border-bottom: 1px solid rgba(255,255,255,.04);
  line-height: 1.4;
}
.pz-perks li:last-child { border-bottom: none; }
.pz-perks li::before {
  content: ''; width: 5px; height: 5px; min-width: 5px; margin-top: 5px;
  background: var(--pz-color, var(--or)); transform: rotate(45deg);
}

/* Grand Champion crown banner */
.pz-crown-banner {
  position: absolute; top: -1px; left: 50%; transform: translateX(-50%);
  white-space: nowrap; z-index: 10;
  font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
  font-size: 10px; letter-spacing: 3px; text-transform: uppercase;
  background: var(--or); color: #080808;
  padding: 5px 20px;
  clip-path: polygon(8px 0%,100% 0%,calc(100% - 8px) 100%,0% 100%);
}

/* ── Special awards row ── */
.special-awards {
  display: grid; grid-template-columns: repeat(4,minmax(0,1fr));
  gap: 12px; margin-top: 2px; position: relative; z-index: 1;
}
.sa-card {
  background: var(--dark2); border: 1px solid rgba(255,255,255,.06);
  padding: 20px 24px; display: flex; align-items: center; gap: 16px;
  transition: all .25s; position: relative; overflow: hidden;
  min-width: 0;
}
.sa-card::before {
  content: ''; position: absolute; left: 0; top: 0; bottom: 0; width: 3px;
  background: var(--or); transform: scaleY(0); transform-origin: bottom;
  transition: transform .3s;
}
.sa-card:hover { border-color: rgba(249,115,22,.2); background: rgba(249,115,22,.04); }
.sa-card:hover::before { transform: scaleY(1); }
.sa-icon-wrap {
  width: 44px; height: 44px; border-radius: 2px; flex-shrink: 0;
  display: flex; align-items: center; justify-content: center;
  background: rgba(249,115,22,.08); border: 1px solid rgba(249,115,22,.15);
  font-size: 22px;
}
.sa-title {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 800;
  font-size: 14px; text-transform: uppercase; letter-spacing: .5px; color: var(--tx);
}
.sa-sub { font-size: 12px; color: var(--tx3); margin-top: 3px; }

.help-resources-sec {
  background:
    radial-gradient(circle at top left, rgba(249,115,22,.12), transparent 26%),
    linear-gradient(180deg, #0d0d0d 0%, #090909 100%);
  border-top: 1px solid rgba(249,115,22,.12);
  border-bottom: 1px solid rgba(249,115,22,.1);
}
.help-resources-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(300px, .85fr);
  gap: 22px;
  align-items: stretch;
}
.help-resource-card,
.help-preview-card {
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(255,255,255,.035), rgba(255,255,255,.02));
  border: 1px solid rgba(255,255,255,.08);
  padding: 28px;
}
.help-resource-card::before,
.help-preview-card::before {
  content: '';
  position: absolute;
  inset: 0 auto auto 0;
  width: 140px;
  height: 2px;
  background: linear-gradient(90deg, var(--or), transparent);
}
.help-resource-card h3,
.help-preview-card h3 {
  font-family: 'Barlow Condensed', sans-serif;
  font-weight: 900;
  font-size: clamp(24px, 3vw, 34px);
  text-transform: uppercase;
  line-height: 1;
  margin-bottom: 14px;
}
.help-resource-card p,
.help-preview-card p {
  font-size: 15px;
  color: var(--tx2);
  line-height: 1.75;
}
.help-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 18px 0 22px;
}
.help-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 34px;
  padding: 0 14px;
  border: 1px solid rgba(249,115,22,.22);
  background: rgba(249,115,22,.08);
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  color: #ffd6bb;
}
.help-preview-list {
  list-style: none;
  display: grid;
  gap: 12px;
  margin-top: 18px;
}
.help-preview-list li {
  position: relative;
  padding-left: 18px;
  color: var(--tx2);
  line-height: 1.65;
}
.help-preview-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 10px;
  width: 7px;
  height: 7px;
  transform: rotate(45deg);
  background: var(--or);
}
.help-cta {
  margin-top: 22px;
}

/* ═══════════════════════════════════════════════
   JOIN CTA — FULL WIDTH BANNER
═══════════════════════════════════════════════ */
.join-sec {
  position: relative; overflow: hidden; padding: 0;
  background: var(--black);
}
.join-inner {
  position: relative; z-index: 2;
  display: grid; grid-template-columns: 1fr 1fr; align-items: center;
  min-height: 460px;
}
.join-bg {
  position: absolute; inset: 0; z-index: 0;
  background-image: url('https://images.unsplash.com/photo-1542751371-adc38448a05e?w=1600&q=70&auto=format');
  background-size: cover; background-position: center;
  opacity: .12;
}
.join-bg-ov {
  position: absolute; inset: 0; z-index: 1;
  background: linear-gradient(90deg, rgba(8,8,8,.98) 40%, rgba(8,8,8,.7) 100%),
    radial-gradient(ellipse 80% 100% at 0% 50%, rgba(249,115,22,.1) 0%, transparent 70%);
}
.join-text { padding: 80px 80px; position: relative; z-index: 2; }
.join-title {
  font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
  font-size: clamp(36px, 5vw, 64px); line-height: 1.0; text-transform: uppercase;
  letter-spacing: .5px; margin-bottom: 16px;
}
.join-title span { color: var(--or); }
.join-sub { font-size: 16px; color: var(--tx2); line-height: 1.7; max-width: 440px; margin-bottom: 36px; }
.join-note {
  margin-top: 14px; font-family: 'Barlow Condensed', sans-serif;
  font-size: 12px; letter-spacing: 2px; text-transform: uppercase; color: var(--tx3);
}
.join-visual {
  position: relative; z-index: 2; display: flex; align-items: center; justify-content: center;
  padding: 40px;
}
.join-image-frame {
  position: relative; width: 100%; max-width: 440px;
  clip-path: polygon(20px 0%, 100% 0%, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0% 100%, 0% 20px);
  overflow: hidden;
}
.join-image-frame img {
  width: 100%; aspect-ratio: 16/9; object-fit: cover; display: block;
  filter: brightness(.8) saturate(1.2);
  transition: filter .3s;
}
.join-image-frame:hover img { filter: brightness(1) saturate(1.4); }
.join-image-frame::before {
  content: ''; position: absolute; inset: 0; z-index: 1;
  border: 2px solid var(--or); opacity: .4;
  clip-path: polygon(20px 0%, 100% 0%, 100% calc(100% - 20px), calc(100% - 20px) 100%, 0% 100%, 0% 20px);
}

/* ═══════════════════════════════════════════════
   FOOTER
═══════════════════════════════════════════════ */
.gamejam-footer {
  position: relative;
  overflow: hidden;
  padding: 56px 80px 36px;
  background:
    radial-gradient(circle at top left, rgba(249,115,22,.16), transparent 34%),
    linear-gradient(180deg, rgba(15,15,15,1) 0%, rgba(8,8,8,1) 100%);
  border-top: 1px solid rgba(249,115,22,.18);
}
.gamejam-footer::before {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    repeating-linear-gradient(90deg, transparent, transparent 109px, rgba(249,115,22,.035) 109px, rgba(249,115,22,.035) 110px),
    linear-gradient(90deg, rgba(249,115,22,.06), transparent 22%, transparent 78%, rgba(249,115,22,.06));
}
.gamejam-footer-inner {
  position: relative;
  z-index: 1;
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.gamejam-footer-top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
}
.gamejam-footer-kicker {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: var(--or);
  margin-bottom: 10px;
}
.gamejam-footer-kicker::before {
  content: '';
  width: 26px;
  height: 2px;
  background: var(--or);
}
.gamejam-footer-title {
  font-family: 'Barlow Condensed', sans-serif;
  font-size: clamp(24px, 3vw, 34px);
  font-weight: 900;
  letter-spacing: .5px;
  text-transform: uppercase;
  color: var(--tx);
}
.gamejam-footer-sub {
  margin-top: 8px;
  font-size: 14px;
  color: var(--tx2);
  line-height: 1.6;
  max-width: 540px;
}
.gamejam-footer-socials {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.gamejam-social-link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  min-height: 48px;
  padding: 12px 18px;
  border: 1px solid rgba(255,255,255,.1);
  background: rgba(255,255,255,.03);
  color: var(--tx);
  text-decoration: none;
  clip-path: var(--clip-both);
  transition: transform .25s ease, border-color .25s ease, box-shadow .25s ease, background .25s ease;
}
.gamejam-social-link:hover {
  transform: translateY(-2px);
  border-color: var(--platform-color);
  background: rgba(255,255,255,.05);
  box-shadow: 0 12px 28px rgba(0,0,0,.24);
}
.gamejam-social-link i {
  font-size: 18px;
  color: var(--platform-color);
}
.gamejam-social-link span {
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 1.5px;
  text-transform: uppercase;
}
.gamejam-footer-copy {
  padding-top: 18px;
  border-top: 1px solid rgba(255,255,255,.08);
  font-family: 'Barlow Condensed', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--tx3);
}

/* ═══════════════════════════════════════════════
   SCROLL REVEAL
═══════════════════════════════════════════════ */
.rv { opacity: 0; transform: translateY(24px); transition: opacity .55s ease, transform .55s ease; }
.rv.on { opacity: 1; transform: none; }

/* ═══════════════════════════════════════════════
   RESPONSIVE
═══════════════════════════════════════════════ */
@media (max-width: 1100px) {
  .hero-body { grid-template-columns: 1fr; gap: 40px; padding: 0 40px; }
  .hero-side-panel { width: min(100%, 440px); justify-self: start; }
  .about-layout { grid-template-columns: 1fr; gap: 48px; }
  .ideas-scroll { grid-template-columns: 1fr; }
  .idea-stack { grid-template-columns: repeat(3, 1fr); }
  .podium { grid-template-columns: 1fr; gap: 16px; }
  .join-inner { grid-template-columns: 1fr; }
  .join-visual { display: none; }
}
@media (max-width: 1440px) and (min-width: 1101px) {
  .hero {
    min-height: calc(100vh - 24px);
    padding-bottom: 52px;
  }
  .hero-body {
    grid-template-columns: minmax(0, 1fr) minmax(270px, 320px);
    gap: 28px;
    max-width: 1240px;
  }
  .hero-live { font-size: 10px; letter-spacing: 2px; padding: 6px 14px; }
  .hero-tag { font-size: 12px; letter-spacing: 6px; }
  .hero-h1 .line1 { font-size: clamp(52px, 6.3vw, 88px); }
  .hero-h1 .line2 { font-size: clamp(42px, 5.4vw, 74px); }
  .hero-sub { max-width: 480px; font-size: 15px; line-height: 1.5; }
  .btn-hero { padding: 13px 26px; font-size: 13px; letter-spacing: 2px; }
  .hero-stats { flex-wrap: wrap; row-gap: 10px; }
  .hstat { padding: 9px 16px; }
  .hstat-val { font-size: 24px; }
  .hstat-lbl { font-size: 10px; letter-spacing: 1.5px; }
  .hero-side-panel { width: min(100%, 320px); }
  .cd-grid { gap: 6px; margin-bottom: 12px; }
  .cd-box { padding: 10px 4px 8px; }
  .cd-title { font-size: 10px; letter-spacing: 2px; }
  .cd-status { font-size: 9px; letter-spacing: 1px; padding: 3px 8px; }
  .cd-num { font-size: 30px; }
  .cd-lbl { font-size: 8px; letter-spacing: 1.5px; }
  .support-btn { min-height: 50px; padding: 12px 14px; }
  .support-kicker { font-size: 9px; }
  .support-label { font-size: 13px; }
  .special-awards { grid-template-columns: repeat(2,minmax(0,1fr)); }
}
@media (max-height: 860px) and (min-width: 1024px) {
  .hero {
    min-height: calc(100vh - 16px);
    padding-top: 16px;
    padding-bottom: 40px;
    justify-content: center;
  }
  .hero-body { align-items: center; }
  .hero-live { margin-bottom: 16px; }
  .hero-tag { margin-bottom: 4px; font-size: 11px; letter-spacing: 5px; }
  .hero-h1 { margin-bottom: 8px; }
  .hero-h1 .line1 { font-size: clamp(48px, 5.8vw, 78px); }
  .hero-h1 .line2 { font-size: clamp(38px, 4.9vw, 66px); }
  .hero-sub {
    font-size: 14px;
    line-height: 1.45;
    margin-bottom: 18px;
  }
  .hero-actions { margin-bottom: 18px; gap: 12px; }
  .btn-hero { padding: 11px 20px; font-size: 12px; letter-spacing: 2px; }
  .hero-stats { row-gap: 8px; }
  .hstat { padding: 8px 16px; }
  .hstat-val { font-size: 22px; }
  .hstat-lbl { font-size: 10px; letter-spacing: 1.5px; }
  .hero-side-panel { width: min(100%, 300px); gap: 10px; }
  .hero-countdown { padding: 18px 16px; }
  .cd-top { margin-bottom: 12px; }
  .cd-grid { gap: 6px; margin-bottom: 10px; }
  .cd-box { padding: 8px 4px; }
  .cd-title { font-size: 10px; letter-spacing: 2px; }
  .cd-status { font-size: 9px; letter-spacing: 1px; padding: 3px 8px; }
  .cd-num { font-size: 28px; }
  .cd-lbl { font-size: 8px; letter-spacing: 1px; }
  .support-btn { min-height: 46px; padding: 10px 12px; }
  .support-icon { font-size: 18px; }
  .support-kicker { font-size: 8px; letter-spacing: 1.5px; }
  .support-label { font-size: 12px; }
  .scroll-hint { display: none; }
}
@media (max-width: 768px) {
  .section, .hero-body { padding-left: 24px; padding-right: 24px; }
  .section { padding-top: 64px; padding-bottom: 64px; }
  .hero { min-height: auto; padding-top: 56px; padding-bottom: 56px; }
  .hero-body { grid-template-columns: 1fr; padding: 0 24px; gap: 32px; }
  .hero-stats { flex-wrap: wrap; gap: 0; }
  .hstat { padding: 10px 20px; }
  .hero-side-panel { width: 100%; }
  .games-header { flex-direction: column; align-items: flex-start; gap: 20px; }
  .games-sec { padding: 64px 24px; }
  .rules-layout { grid-template-columns: 1fr; }
  .idea-spotlight { padding: 28px 24px 24px; }
  .idea-topline, .idea-head { flex-direction: column; align-items: flex-start; }
  .idea-title { font-size: 30px; }
  .idea-points, .idea-stack { grid-template-columns: 1fr; }
  .tl-phases { grid-template-columns: 1fr; }
  .tl-bar-wrap { display: none; }
  .prize-arena { grid-template-columns: 1fr; }
  .prizes-sec::before { animation: none; background-image: none; }
  .prizes-sec::after { background: none; }
  .prize-total-bar { margin-bottom: 28px; padding: 16px 18px; gap: 14px; }
  .ptb-val { text-shadow: none; }
  .pz-card { transition: none; }
  .pz-card:hover { transform: none; }
  .pz-inner { padding: 28px 20px 24px; }
  .pz-first { box-shadow: none; background: rgba(249,115,22,.06); }
  .pz-first .pz-scan,
  .pz-first .pz-sweep,
  .pz-first .pz-trophy::before { display: none; }
  .pz-first .pz-amount,
  .pz-second .pz-amount,
  .pz-third .pz-amount { text-shadow: none; animation: none; }
  .pz-crown-banner { letter-spacing: 2px; padding: 5px 14px; }
  .special-awards { grid-template-columns: repeat(2,minmax(0,1fr)); gap: 10px; }
  .sa-card { padding: 18px 20px; gap: 14px; align-items: flex-start; }
  .help-resources-grid { grid-template-columns: 1fr; }
  .help-resource-card, .help-preview-card { padding: 22px; }
  .join-text { padding: 60px 24px; }
  .gamejam-footer { padding: 40px 24px 28px; }
  .gamejam-footer-top { align-items: flex-start; }
  .gamejam-footer-socials { gap: 10px; }
  .cards-grid { grid-template-columns: 1fr; }
}
  /* Default (mobile first) */
.desktop-padding {
  padding: 0px 16px; /* mobile */
}

/* Desktop only */
@media (min-width: 1024px) {
  .desktop-padding {
    padding: 0px 80px;
  }
}
@media (max-width: 480px) {
  .idea-number { font-size: 52px; }
  .idea-title { font-size: 26px; }
  .special-awards { grid-template-columns: 1fr; }
  .sa-card { padding: 16px 18px; gap: 12px; }
  .sa-icon-wrap { width: 40px; height: 40px; font-size: 20px; }
  .sa-title { font-size: 13px; }
  .sa-sub { font-size: 11px; }
}`}
      </style>




      <section className="hero" id="home">

        <div className="hero-media">
          <div className="hero-bg-img"></div>
        </div>


        <div className="hero-ov1"></div>
        <div className="hero-ov2"></div>
        <div className="hero-scanlines"></div>
        <div className="hero-grid-ov"></div>


        <div className="hero-body">

          <div className="hero-content">
            <div className="hero-live"><span className="live-dot"></span> Registration Open · {daysBetween(game_jam?.sub_start_dt ? new Date(game_jam.sub_start_dt) : new Date(), game_jam?.sub_end_dt ? new Date(game_jam.sub_end_dt) : new Date()) || 0} days</div>
            <span className="hero-tag">CGES.CLUB Presents</span>
            <h1 className="hero-h1">
              <span className="line1">CGES GAMEJAM</span>
              <span className="line2">2026</span>
            </h1>
            <p className="hero-sub">
              Build your first playable Web game in <strong>{daysBetween(game_jam?.sub_start_dt ? new Date(game_jam.sub_start_dt) : new Date(), game_jam?.sub_end_dt ? new Date(game_jam.sub_end_dt) : new Date()) || 0} days</strong>. Submit on CGES.club. Get played by thousands. Win real prizes.
            </p>
            <div className="hero-actions">

              {/* {(user_register_stat === false && game_jam?.is_ends_on === true || game_jam?.is_ends_on === true) ? <span className="btn-hero primary opacity-75" disabled>Registration Closed<span className="btn-arrow"></span></span> :

                <Link to="/gamejam-register"
                  state={{ event_id: game_jam?.event_id, isregister: user_register_stat }}
                  onClick={(e) => {
                    if (!user?.user_id) {
                      e.preventDefault();
                      OpenModal();
                      return;
                    }
                  }}
                >
                  <span className="btn-hero primary">{user_register_stat ? "Edit Submission " : "Register Free"}<span className="btn-arrow">→</span></span>
                </Link>
              } */}
              {(user_register_stat === false && game_jam?.is_ends_on || game_jam?.is_ends_on) ? (
                <span className="btn-hero primary opacity-75" disabled>
                  Registration Closed
                  <span className="btn-arrow"></span>
                </span>

              ) : game_jam?.is_upcoming ? (
                <span className="btn-hero primary opacity-75" disabled>
                  Registration Soon
                  <span className="btn-arrow"></span>
                </span>

              ) : (
                <Link
                  to="/gamejam-register"
                  state={{ event_id: game_jam?.event_id, isregister: user_register_stat }}
                  onClick={(e) => {
                    if (!user?.user_id) {
                      e.preventDefault();
                      OpenModal();
                      return;
                    }
                  }}
                >
                  <span className="btn-hero primary">
                    {user_register_stat ? "Edit Submission" : "Register Free"}
                    <span className="btn-arrow">→</span>
                  </span>
                </Link>
              )}

              <Link to="/gamejam-listing">
                <span className="btn-hero ghost">Submitted Games <span className="btn-arrow">→</span></span>
              </Link>
            </div>
            <div className="hero-stats">
              <div className="hstat">
                <span className="hstat-val">{daysBetween(game_jam?.sub_start_dt ? new Date(game_jam.sub_start_dt) : new Date(), game_jam?.sub_end_dt ? new Date(game_jam.sub_end_dt) : new Date()) || 0}</span>
                <span className="hstat-lbl">Days to Build</span>
              </div>
              <div className="hstat">
                <span className="hstat-val">Free</span>
                <span className="hstat-lbl">Entry</span>
              </div>
              <div className="hstat">
                <span className="hstat-val">₹10,000</span>
                <span className="hstat-lbl">Prize Pool</span>
                <span className="hstat-lbl">(Educational Scholarship)</span>
              </div>
              <div className="hstat">
                <span className="hstat-val">WebGL</span>
                <span className="hstat-lbl">Platform</span>
              </div>
            </div>
          </div>


          <div className="hero-side-panel">
            <div className="hero-countdown">
              <div className="cd-top">
                <span className="cd-title">
                  {isSubmissionEnded
                    ? "GameJam Submission"
                    : game_jam?.is_upcoming
                      ? "Upcoming GameJam In"
                      : "GameJam Closes In"}
                </span>
                <span className="cd-status">
                  {isSubmissionEnded ? "Ended" : game_jam?.is_upcoming ? "Upcoming" : "Live Now"}
                </span>
              </div>
              {isSubmissionEnded ? (
                <div className="cd-ended"> {game_jam?.is_ends_on ? "GameJam Ended" : " Voting has Started"}</div>
              ) : (
                <div className="cd-grid">
                  <div className="cd-box"><span className="cd-num" id="cd-d">{timeLeft.dd}</span><span className="cd-lbl">Days</span></div>
                  <div className="cd-box"><span className="cd-num" id="cd-h">{timeLeft.hh}</span><span className="cd-lbl">Hours</span></div>
                  <div className="cd-box"><span className="cd-num" id="cd-m">{timeLeft.mm}</span><span className="cd-lbl">Mins</span></div>
                  <div className="cd-box"><span className="cd-num" id="cd-s">{timeLeft.ss}</span><span className="cd-lbl">Secs</span></div>
                </div>
              )}
              {!isSubmissionEnded ? (
                <span className="cd-title">AT {game_jam?.is_upcoming ? game_jam?.starts_on : game_jam?.ends_on || "0.0.0.0"}&nbsp;IST</span>
              ) : null}

              {
                isSubmissionEnded ? (
                  <div className="cd-title">{game_jam?.is_ends_on ? null : game_jam?.ends_on || "0.0.0.0"}&nbsp;{game_jam?.is_ends_on ? null : "IST"}</div>
                ) : null
              }
            </div>
            <a
              className="support-btn discord-support-btn"
              href="https://discord.gg/DGRWQ298Y5"
              target="_blank"
              rel="noreferrer"
              aria-label="Join Discord for Game Jam support"
            >
              <span className="support-icon discord-support-icon"><i className="fab fa-discord"></i></span>
              <span className="support-copy">
                <span className="support-kicker">Need Help?</span>
                <span className="support-label">Join Discord Support</span>
              </span>
            </a>
            <a
              className="support-btn email-support-btn"
              href="mailto:support@cges.club"
              aria-label="Email Game Jam support at support@cges.club"
            >
              <span className="support-icon email-support-icon"><i className="fas fa-envelope"></i></span>
              <span className="support-copy">
                <span className="support-kicker">Email Support</span>
                <span className="support-label">support@cges.club</span>
              </span>
            </a>
          </div>
        </div>

        <div className="scroll-hint">
          <span>Scroll</span>
          <div className="scroll-arrow"></div>
        </div>
      </section>

      {/* {Games.length !== 0 ?      */}
      <section className="games-sec" id="games">
        <div className="si" style={{ position: 'relative', zIndex: 1 }}>

          <div className="games-header rv">
            <div>
              <div className="sec-eyebrow">Featured Entries</div>
              <h2 className="sec-title">Play <span className="hl">Submitted games</span></h2>
            </div>
          </div>

          <div className="games-grid rv">
            {Games.length !== 0 ?
              Games.map((item, index) => {
                return (
                  <div key={index}>
                    <div className="game-card" onClick={() => { window.location.href = item.game_url }}>
                      <div className="gc-thumb">
                        <img className="gc-thumb-img" src={item.game_thumbnail+`?v=${item.crd_on}`} alt={item.title} />
                        <div className="gc-top">
                          {/* <span className="gc-rank">#{index + 1}</span> */}
                          {/* <span className="gc-status">WebGL</span> */}
                        </div>
                        <Link to={item.game_url}>
                          <button className="gc-play-btn" title="Play now"></button>
                        </Link>
                      </div>
                      <div className="gc-info">
                        <div className="gc-name" title={item.title}>
                          {formatSubmittedGameTitle(item.title)}
                        </div>
                        <div className="gc-meta">
                          {/* <span className="gc-votes"><span className="gc-votes-icon">&#9650;</span>2,841 votes</span> */}
                          {/* <span className="gc-tag gt-a">Action</span> */}
                        </div>
                        <div className="gc-play-row">
                          {/* <button className="gc-play-full"
                        
                        ><span className="play-arrow"></span>Play now</button> */}
                          <Link to={item.game_url} className="gc-play-full">
                            <span className="play-arrow"></span>Play nOw</Link>
                          <button className="gc-vote-btn" type="button" aria-label={`${item.votes ?? 0} votes`} title={`${item.votes ?? 0} votes`}>
                            <i className="fas fa-star" aria-hidden="true"></i>
                            {item.votes ?? 0}
                          </button>
                        </div>
                      </div>
                    </div></div>)
              })
              :
              null
            }

          </div>
          {
            Games.length === 0 ?
              <div className="d-flex justify-content-center">
                <div className="sec-eyebrow text-center">Be the first to submit your game!</div> &nbsp;&nbsp;
                <div className="sec-eyebrow text-center"></div>
              </div> : null
          }

          {
            Games.length !== 0 ?
              <div className="games-footer" style={{ display: Games ? "flex" : "none" }}>
                <a href="/gamejam-listing" className="btn-hero ghost" style={{ fontSize: '13px', padding: '12px 40px', letterSpacing: '2px' }}>
                  View All Games &nbsp;&rarr;
                </a>
              </div> : null
          }



        </div>
      </section>
      {/* : null} */}

      <section className="section about-sec" id="about">
        <div className="si">
          <div className="about-layout">
            <div className="about-text rv">
              <div className="sec-eyebrow">01 - The Challenge</div>
              <h2 className="sec-title">One month.<br />One game.<br /><span className="hl">Real rewards.</span></h2>
              <div className="sec-divider"></div>
              <p className="lead">
                CGES GameJam is a <strong>student-only game development challenge</strong> - 60 days to take an idea from zero to a fully playable Unity WebGL game, live on CGES.club for the world to Play, Vote, and Share.
              </p>
              <ul className="feat-list">
                <li>Build with Unity, export as WebGL - browser-native gaming</li>
                <li>3D assets with Blender, free asset packs allowed</li>
                <li>Games go live on CGES.club for community voting</li>
                <li>Open to all skill levels - zero to hero</li>
                <li>Solo entries are also welcome, no team required</li>
              </ul>
            </div>
            <div className="cards-grid rv ">
              <div className="info-card position-relative" style={{ '--card-c': 'var(--or)' }}>
                <span className="ic-icon" style={{ color: "#ff810e" }}><i className="fas fa-clock"></i></span>
                <div className="ic-title">60-Day Sprint</div>
                <p className="ic-text">One focused month to design, develop, and Publish. Clock starts Day 1.</p>
                <div className="position-absoulte" style={{ bottom: 0, left: 0, right: 0 }}>
                  <span className="ic-badge">Day 1 → Day 60</span>
                </div>
              </div>
              <div className="info-card position-relative" style={{ '--card-c': '#ef4444' }}>
                <span className="ic-icon" style={{ color: "#ff810e" }}><i className="fas fa-gamepad"></i></span>
                <div className="ic-title">Unity WebGL</div>
                <p className="ic-text">Build in Unity, export as WebGL. Instantly playable in any browser — no installs.</p>
                <div className="position-absoulte" style={{ bottom: 0, left: 0, right: 0 }}>
                  <span className="ic-badge">Unity Engine Required</span>
                </div>
              </div>
              <div className="info-card position-relative" style={{ '--card-c': '#22c55e' }}>
                <span className="ic-icon" style={{ color: "#ff810e" }}><i className="fas fa-globe"></i></span>
                <div className="ic-title">Live Platform</div>
                <p className="ic-text">Approved games go live on CGES.club with real players, votes, and comments.</p>
                <div className="position-absoulte" style={{ bottom: 0, left: 0, right: 0 }}>
                  <span className="ic-badge">Public Audience</span>
                </div>
              </div>
              <div className="info-card position-relative" style={{ '--card-c': '#a78bfa' }}>
                <span className="ic-icon" style={{ color: "#ff810e" }}><i className="fas fa-user-graduate" ></i></span>
                <div className="ic-title">Students Only</div>
                <p className="ic-text">Exclusively for students aged 13+. only India, any institution.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                <div className="position-absoulte" style={{ bottom: 0, left: 0, right: 0 }}>
                  <span className="ic-badge">Age 13+</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="section ideas-sec" id="ideas">
        <div className="si">
          <div className="rv">
            <div className="sec-eyebrow">02 — Puzzle Brief</div>
            <h2 className="sec-title">One genre. One challenge.<br /><span className="stroke">Build a puzzle game.</span></h2>
            <div className="sec-divider"></div>
          </div>
          <div className="ideas-scroll">
            <div className="idea-spotlight rv">
              <div className="idea-topline">
                <span className="idea-number">01</span>
                <span className="idea-chip ic-p">Theme: 2D or 3D Puzzle</span>
              </div>
              <div className="idea-head">
                <span className="idea-icon" style={{ color: "#ff810e" }}><i className="fas fa-puzzle-piece"></i></span>
                <div>
                  <div className="idea-label">Creative Game Jam Genre</div>
                  <h3 className="idea-title">Design and build a creative 2D or 3D <span style={{ color: "#ff810e" }}>puzzle</span> game</h3>
                </div>
              </div>
              <p className="idea-desc">
                Focus on unique mechanics, engaging gameplay, and clever problem-solving gaming experiences. Your game can be minimal or atmospheric,
                but it should challenge players to think, experiment, and discover satisfying gaming experience within the browser.
              </p>
              <div className="idea-points">
                <div className="idea-point">
                  <span className="idea-point-k">Core Focus</span>
                  <span className="idea-point-v">Unique puzzle mechanics</span>
                </div>
                <div className="idea-point">
                  <span className="idea-point-k">Feel</span>
                  <span className="idea-point-v">Clever and engaging</span>
                </div>
                <div className="idea-point">
                  <span className="idea-point-k">Platform</span>
                  <span className="idea-point-v">Web playable</span>
                </div>
              </div>
            </div>
            <div className="idea-stack">
              <div className="idea-card rv">
                <span className="idea-chip ic-or">Mechanics</span>
                <div className="idea-mini-title">Build around one smart interaction</div>
                <p className="idea-mini-desc">Think gravity shifts, light reflection, shape swapping, cloning, portals, timing loops, or any system players can learn and master.</p>
              </div>
              <div className="idea-card rv">
                <span className="idea-chip ic-gr">Experience</span>
                <div className="idea-mini-title">Make every level teach something</div>
                <p className="idea-mini-desc">Start simple, reveal depth gradually, and reward experimentation with aha moments instead of random difficulty spikes.</p>
              </div>
              <div className="idea-card rv">
                <span className="idea-chip ic-v">Platform</span>
                <div className="idea-mini-title">Keep it polished for the web</div>
                <p className="idea-mini-desc">Fast load times, readable visuals, and intuitive controls matter just as much as the puzzle idea itself in a browser-first game.</p>
              </div>
            </div>
            <div style={{ display: "none" }}>
            <div className="idea-card rv">
              <span className="idea-number">02</span>
              <span className="idea-icon" style={{ color: "#ff810e" }}><i className="fas fa-puzzle-piece"></i></span>
              <div className="idea-title">Block Puzzle</div>
              <p className="idea-desc">Slide, match, or rotate blocks. Deep mechanics with minimal art — let the logic shine.</p>
              <span className="idea-chip ic-p">Puzzle</span>
            </div>
            <div className="idea-card rv">
              <span className="idea-number">03</span>
              <span className="idea-icon" style={{ color: "#ff810e" }}><i className="fas fa-user"></i></span>
              <div className="idea-title">2D Platformer</div>
              <p className="idea-desc">Run, jump, collect. Add a twist: gravity flip, time rewind, or a unique mechanic.</p>
              <span className="idea-chip ic-pl">Platformer</span>
            </div>
            <div className="idea-card rv">
              <span className="idea-number">04</span>
              <span className="idea-icon" style={{ color: "#ff810e" }}><i className="fas fa-map"></i></span>
              <div className="idea-title">Top-Down RPG</div>
              <p className="idea-desc">Explore a small world, interact with NPCs, solve quests. Narrative-driven and expressive.</p>
              <span className="idea-chip ic-v">Adventure</span>
            </div>
            <div className="idea-card rv">
              <span className="idea-number">05</span>
              <span className="idea-icon" style={{ color: "#ff810e" }}><i className="fas fa-rocket"></i></span>
              <div className="idea-title">Shoot-em-Up</div>
              <p className="idea-desc">Waves of enemies, a ship that fires, power-ups to grab. Fast to prototype, endless fun.</p>
              <span className="idea-chip ic-ar">Arcade</span>
            </div>
            </div>
          </div>
        </div>
      </section>


      <section className="section rules-sec" id="rules">
        <div className="si">
          <div className="rv">
            <div className="sec-eyebrow">03 — Rules</div>
            <h2 className="sec-title">Know the <span className="hl">rules</span> before you build</h2>
            <div className="sec-divider"></div>
          </div>
          <div className="rules-layout">
            <div>
              <div className="rules-col-head ok">✓   Allowed</div>
              <div className="rule-item rv"><span className="ri-ico" style={{ color: "#28a745" }}><i className="fas fa-check-circle"></i></span><p className="ri-text"><strong>Unity (any version)</strong> with WebGL build target - the only accepted engine.</p></div>
              <div className="rule-item rv"><span className="ri-ico" style={{ color: "#28a745" }}><i className="fas fa-check-circle"></i></span><p className="ri-text"><strong>Blender</strong> for 3D modeling and asset creation - export directly to Unity.</p></div>
              <div className="rule-item rv"><span className="ri-ico" style={{ color: "#28a745" }}><i className="fas fa-check-circle"></i></span><p className="ri-text"><strong>Free asset packs</strong> from Unity Store (free tier), itch.io, and open-licensed sources.</p></div>
              <div className="rule-item rv"><span className="ri-ico" style={{ color: "#28a745" }}><i className="fas fa-check-circle"></i></span><p className="ri-text"><strong>Solo entry</strong> - no team required. Any student can participate alone.</p></div>
              <div className="rule-item rv"><span className="ri-ico" style={{ color: "#28a745" }}><i className="fas fa-check-circle"></i></span><p className="ri-text"><strong>Personal code libraries</strong> or reusable code written before the jam starts.</p></div>
              <div className="rule-item rv"><span className="ri-ico" style={{ color: "#28a745" }}><i className="fas fa-check-circle"></i></span><p className="ri-text"><strong>Only allowed genres</strong> - submissions must belong to approved game genres only.</p></div>
            </div>
            <div>
              <div className="rules-col-head bad">✕   Not Allowed</div>
              <div className="rule-item rv"><span className="ri-ico" style={{ color: "#dc3545" }}><i className="fas fa-times-circle"></i></span><p className="ri-text"><strong>Paid or licensed assets</strong> - no purchased packs, proprietary IP, or branded characters.</p></div>
              <div className="rule-item rv"><span className="ri-ico" style={{ color: "#dc3545" }}><i className="fas fa-times-circle"></i></span><p className="ri-text"><strong>Other engines</strong> - are not accepted.</p></div>
              <div className="rule-item rv"><span className="ri-ico" style={{ color: "#dc3545" }}><i className="fas fa-times-circle"></i></span><p className="ri-text"><strong>Pre-existing games</strong> - all content must be created within the 60-day window.</p></div>
              <div className="rule-item rv"><span className="ri-ico" style={{ color: "#dc3545" }}><i className="fas fa-times-circle"></i></span><p className="ri-text"><strong>Non-students or under-13s</strong> - enrollment verification may be requested.</p></div>
              <div className="rule-item rv"><span className="ri-ico" style={{ color: "#dc3545" }}><i className="fas fa-times-circle"></i></span><p className="ri-text"><strong>Offensive or harmful content</strong> - must comply with <Link to="/community-guidelines" style={{ fontSize: "inherit" }} className="color-base">CGES community guidelines</Link>.</p></div>
              <div className="rule-item rv"><span className="ri-ico" style={{ color: "#dc3545" }}><i className="fas fa-times-circle"></i></span><p className="ri-text"><strong>Non-functional builds</strong> - your WebGL game must load and run in a browser.</p></div>
            </div>
          </div>
        </div>
      </section>


      <section className="section tl-sec" id="timeline">
        <div className="si">
          <div className="rv">
            <div className="sec-eyebrow">04 — Schedule</div>
            <h2 className="sec-title">the <span className="hl">60-Day</span> Journey</h2>
            <div className="sec-divider"></div>
          </div>

          <div className="tl-bar-wrap rv">

            <div className="tl-progress">
              <div className="tl-progress-fill"></div>
            </div>

            <div className="tl-markers">
              <div className="tl-mark done" style={{ transform: 'none' }}></div>
              <div className="tl-mark done" style={{ transform: 'translateX(-50%)' }}></div>
              <div className="tl-mark current" style={{ transform: 'translateX(-100%)' }}></div>
            </div>
          </div>


          <div className="tl-phases rv">


            <div className="tl-phase ph-active">
              <span className="ph-icon" style={{ color: "#ff810e" }}><i className="fas fa-rocket"></i></span>
              <span className="ph-badge ph-badge-corner"><span className="ph-badge-dot"></span>Completed</span>
              <span className="ph-range">Day 1 - 60</span>
              <span className="ph-label">Build Period</span>
              <span className="ph-sub">Days 1 – 60</span>
              <p className="ph-desc">The jam is live. Start building your Unity WebGL game from scratch. Only allowed genres - just submit playable game that you love.</p>
              {/* <span className="ph-badge"><span className="ph-badge-dot"></span>Currently Active</span> */}
              <ul className="ph-steps">
                <li>Day 1 - Registration opens, clock starts</li>
                <li>Day 60 - Final WebGL build submission deadline, Registration closes.</li>
              </ul>
            </div>


            <div className="tl-phase ph-voting">
              <span className="ph-icon" style={{ color: "#ff810e" }}><i className="fas fa-vote-yea"></i></span>
              <span className="ph-badge ph-badge-corner"><span className="ph-badge-dot"></span>Completed</span>

              <span className="ph-range">Day 30 – 60</span>
              <span className="ph-label">Voting Period</span>
              <span className="ph-sub">30 Days of Community Votes</span>
              <p className="ph-desc">All submitted games go live on CGES.club. The community plays, votes. Every registered user gets a vote - make your game count.</p>
              {/* <span className="ph-badge"><span className="ph-badge-dot"></span>Upcoming</span> */}
              <ul className="ph-steps">
                <li>Games published on CGES.club immediately</li>
                <li>Community votes open to all registered users</li>
                <li>Expert judge panel reviews in parallel</li>
                <li>Day 60 - Voting closes & scores locked</li>
              </ul>
            </div>


            <div className="tl-phase ph-upcoming">
              <span className="ph-icon" style={{ color: "#ff810e" }}><i className="fas fa-trophy"></i></span>
              <span className="ph-badge ph-badge-corner"><span className="ph-badge-dot"></span>Stay Tuned</span>
              <span className="ph-range">Day 60+</span>
              <span className="ph-label">Results</span>
              <span className="ph-sub">Winners Announced</span>
              <p className="ph-desc">Combined scores from community votes and judge panel determine the final rankings. Winners receive cash prizes, platform features, and recognition.</p>
              <ul className="ph-steps">
                <li>Final rankings calculated and verified</li>
                <li>If votes are equal, earlier submission gets priority.</li>
                <li>Cash prizes distributed directly</li>
                <li>Top games featured permanently on CGES.club</li>
              </ul>
            </div>

          </div>
        </div>
      </section>
      <section className="section prizes-sec desktop-padding">
        <div className="si" style={{ position: 'relative', zIndex: 1 }}>


          <div className="rv" style={{ marginTop: '40px' }}>
            <h2 className="sec-title">Judging <span className="hl">Criteria</span></h2>
          </div>

          <div className="special-awards rv">
            <div className="sa-card">
              <div className="sa-icon-wrap" style={{ color: "#ff810e" }}><i className="fas fa-gamepad"></i></div>
              <div><div className="sa-title">Gameplay</div><div className="sa-sub">Core mechanics, balance, and overall fun factor</div></div>
            </div>
            <div className="sa-card">
              <div className="sa-icon-wrap" style={{ color: "#ff810e" }}><i className="fas fa-paint-brush"></i></div>
              <div><div className="sa-title">Visual Design</div><div className="sa-sub">Art direction, polish, and clarity of presentation</div></div>
            </div>
            <div className="sa-card">
              <div className="sa-icon-wrap" style={{ color: "#ff810e" }}><i className="fa-brands fa-unity"></i></div>
              <div><div className="sa-title">Best Game Mechanics</div><div className="sa-sub">Smart systems, responsive controls, and satisfying gameplay loops</div></div>
            </div>
            <div className="sa-card">
              <div className="sa-icon-wrap" style={{ color: "#ff810e" }}><i className="fas fa-users"></i></div>
              <div><div className="sa-title">Community Voting</div><div className="sa-sub">Player engagement, vote support, and how strongly the game resonates with the audience</div></div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="section special-awards-sec" id="judging"> */}

      <section className="section prizes-sec" id="prizes">
        <div className="si" style={{ position: 'relative', zIndex: 1 }}>
          <div className="rv">
            <div className="sec-eyebrow">05 — Prize Pool</div>
            <h2 className="sec-title">₹10,000 <span className="hl">in rewards</span></h2>
            <div className="sec-divider"></div>
          </div>


          <div className="prize-total-bar rv">
            <div>
              <div className="ptb-label">Total Prize Pool</div>
              <div className="ptb-val">₹10,000</div>
            </div>
            <div className="ptb-sep"></div>
            <div className="ptb-note">· Rewards · Certificates · Featuring on CGES</div>
          </div>


          <div className="prize-arena rv">

            <div className="pz-card pz-second" style={{ '--pz-color': 'var(--silver)' }}>
              <div className="pz-inner">
                <div className="pz-rank-badge" style={{ '--pz-color': 'var(--silver)' }}>
                  <span className="pz-rank-dot" style={{ background: 'var(--silver)' }}></span>2nd Place
                </div>
                <div className="pz-trophy">
                  <span className="pz-trophy-icon">🥈</span>
                </div>
                <span className="pz-place">2nd Place</span>
                <span className="pz-title" style={{ '--pz-color': 'var(--silver)' }}>Elite</span>
                <span className="pz-amount">₹{game_jam?.reward_dist?.[2] || 0}</span>
                <span className="pz-reward-lbl">Cash Reward</span>
                <div className="pz-divider" style={{ '--pz-color': 'var(--silver)' }}></div>
                <ul className="pz-perks" style={{ '--pz-color': 'var(--silver)' }}>
                  <li>Cash prize - direct payout</li>
                  <li>CGES Homepage feature</li>
                  {/* <li>Pro membership (6 months)</li> */}
                  <li>Achievement certificate</li>
                </ul>
              </div>
            </div>


            <div className="pz-card pz-first" style={{ '--pz-color': 'var(--or)' }}>
              <div className="pz-crown-banner">⚡ Grand Champion ⚡</div>
              <div className="pz-scan"></div>
              <div className="pz-sweep"></div>
              <div className="pz-inner">
                <div className="pz-rank-badge" style={{ marginTop: '16px', '--pz-color': 'var(--or)' }}>
                  <span className="pz-rank-dot"></span>1st Place · Champion
                </div>
                <div className="pz-trophy">
                  <span className="pz-trophy-icon">🥇</span>
                </div>
                <span className="pz-place">1st Place</span>
                <span className="pz-title">Champion</span>
                <span className="pz-amount">₹{game_jam?.reward_dist?.[1] || 0}</span>
                <span className="pz-reward-lbl">Cash Reward</span>
                <div className="pz-divider"></div>
                <ul className="pz-perks">
                  <li>Cash prize - direct payout</li>
                  <li>CGES Homepage feature</li>
                  {/* <li>Pro membership (1 year)</li> */}
                  <li>Developer spotlight interview</li>
                  <li>Achievement certificate</li>
                </ul>
              </div>
            </div>


            <div className="pz-card pz-third" style={{ '--pz-color': '#cd7c2f' }}>
              <div className="pz-inner">
                <div className="pz-rank-badge" style={{ '--pz-color': '#cd7c2f' }}>
                  <span className="pz-rank-dot" style={{ background: '#cd7c2f' }}></span>3rd Place
                </div>
                <div className="pz-trophy">
                  <span className="pz-trophy-icon">🥉</span>
                </div>
                <span className="pz-place">3rd Place</span>
                <span className="pz-title" style={{ '--pz-color': '#cd7c2f' }}>Finalist</span>
                <span className="pz-amount">₹{game_jam?.reward_dist?.[3] || 5000}</span>
                <span className="pz-reward-lbl">Cash Reward</span>
                <div className="pz-divider" style={{ '--pz-color': '#cd7c2f' }}></div>
                <ul className="pz-perks" style={{ '--pz-color': '#cd7c2f' }}>
                  <li>Cash prize - direct payout</li>
                  <li>CGES Homepage feature</li>
                  <li>Achievement certificate</li>
                </ul>
              </div>
            </div>

          </div>

        </div>
      </section>


      <section className="section help-resources-sec" id="resources">
        <div className="si">
          <div className="rv">
            <div className="sec-eyebrow">06 - Need Help</div>
            <h2 className="sec-title">WebGL build <span className="hl">resources</span></h2>
            <div className="sec-divider"></div>
          </div>

          <div className="help-resources-grid">
            <div className="help-resource-card rv">
              <h3>Need help taking your Unity WebGL build?</h3>
              <p>
                We added a simple walkthrough page for participants who are new to Unity Export Settings.
                It covers module setup, switching to Web, Build settings, Testing, and the most common
                issue people hit before submission.
              </p>
              <div className="help-chip-row">
                <span className="help-chip"><i className="fa-brands fa-unity"></i> Unity Hub setup</span>
                <span className="help-chip"><i className="fas fa-globe"></i> Web build profiles</span>
                <span className="help-chip"><i className="fas fa-image"></i> Screenshots included</span>
              </div>
              <Link to="/gamejam/webgl-help" className="btn-hero primary help-cta">
                Open Full Guide <span className="btn-arrow"><i className="fas fa-arrow-right"></i></span>
              </Link>
            </div>

            <div className="help-preview-card rv">
              <h3>What you will find</h3>
              <p>
                A separate resource page based on the shared document, with extracted guide images and
                step-by-step instructions you can follow while exporting your build.
              </p>
              <ul className="help-preview-list">
                <li>How to add WebGL Build Support in Unity Hub</li>
                <li>Where to switch platform and include scenes</li>
                <li>Which Player Settings matter before exporting</li>
                <li>Why local `index.html` testing can fail without a server</li>
              </ul>
            </div>
          </div>
        </div>
      </section>


      <section className="join-sec" id="join">
        <div className="join-bg"></div>
        <div className="join-bg-ov"></div>
        <div className="join-inner">
          <div className="join-text rv">
            <div className="sec-eyebrow" style={{ marginBottom: '20px' }}>Register Now · Free Entry</div>
            <h2 className="join-title">Submit your<br />first game.<br /><span>Win real prizes.</span></h2>
            <p className="join-sub">60 days. Unity WebGL. Thousands of players on CGES.club. No experience required - just the courage to start.</p>
            {/* <a href="/gamejam-register" target="_blank" className="btn-hero primary" style={{ fontSize: '16px', padding: '18px 52px' }}>
              Register Now <span className="btn-arrow">↗</span>
            </a> */}
            {(user_register_stat === false && game_jam?.is_ends_on || game_jam?.is_ends_on) ? (
              <span className="btn-hero primary opacity-75" disabled>
                Registration Closed
                <span className="btn-arrow"></span>
              </span>

            ) : game_jam?.is_upcoming ? (
              <span className="btn-hero primary opacity-75" disabled>
                Registration Soon
                <span className="btn-arrow"></span>
              </span>

            ) : (
              <Link
                to="/gamejam-register"
                state={{ event_id: game_jam?.event_id, isregister: user_register_stat }}
                onClick={(e) => {
                  if (!user?.user_id) {
                    e.preventDefault();
                    OpenModal();
                    return;
                  }
                }}
              >
                <span className="btn-hero primary">
                  {user_register_stat ? "Edit Submission" : "Register Free"}
                  <span className="btn-arrow">→</span>
                </span>
              </Link>
            )}
            <p className="join-note">Students only · Age 13+ · Unity WebGL required</p>
          </div>
          <div className="join-visual rv">
            <div className="join-image-frame">
              <img src="https://images.unsplash.com/photo-1511512578047-dfb367046420?w=800&q=80&auto=format" alt="Gaming setup" />
            </div>
          </div>
        </div>
      </section>

      <footer className="gamejam-footer">
        <div className="gamejam-footer-inner">
          <div className="gamejam-footer-top">
            <div className="rv">
              <div className="gamejam-footer-kicker">Follow Us On</div>
              <h2 className="gamejam-footer-title">Stay connected with CGES</h2>
              <p className="gamejam-footer-sub">
                Follow us for community updates, game jam news, creator spotlights, and live event moments.
              </p>
            </div>

            <div className="gamejam-footer-socials rv">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  className="gamejam-social-link"
                  style={{ "--platform-color": social.color }}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={social.name}
                >
                  <i className={social.icon} aria-hidden="true"></i>
                  <span>{social.name}</span>
                </a>
              ))}
            </div>
          </div>

          <div className="gamejam-footer-copy">
            © 2026 ChennaiGames Studio Pvt. Ltd. All rights reserved.
          </div>
        </div>
      </footer>
    </>
  );
}

/**
 * Calculates the number of days between two dates, ignoring timezones.
 * 
 * @param {Date} date1 The first date.
 * @param {Date} date2 The second date.
 * @returns {number} The absolute difference in full days.
 */
function daysBetween(date1, date2) {
  // Number of milliseconds in one day
  const oneDayMs = 1000 * 60 * 60 * 24;

  // Convert both dates to UTC timestamps (at midnight) to ignore local timezone effects
  const utc1 = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate());
  const utc2 = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate());

  // Calculate the difference in milliseconds and convert to days, using Math.floor
  // for a whole number result
  return Math.floor(Math.abs(utc2 - utc1) / oneDayMs);
}
const OpenModal = () => {
  if (window.UIkit && typeof window.UIkit.modal === "function") {
    window.UIkit.modal("#modal-login", { container: false }).show();
  }
};
